export * as illustrationDesktop from './illustration-desktop.jpg'
export * as illustrationLaptop from './illustration-laptop.jpg'
export * as illustrationTablet from './illustration-tablet.jpg'
export * as illustrationMobile from './illustration-mobile.jpg'
